import { TextSizeType } from './typographyTypes';
import { COLORS, STYLE } from '@ydistri/theme';
import { CSSProperties } from 'react';
import { css, styled } from 'styled-components';

export type TextType = 'default' | 'danger' | 'success' | 'light' | 'warning' | 'primary';

export interface TextProps {
  $size?: TextSizeType;
  $bold?: boolean;
  $italic?: boolean;
  $semiBold?: boolean;
  $width?: CSSProperties['width'];
  $maxWidth?: CSSProperties['maxWidth'];
  $type?: TextType;
  $center?: boolean;
  $right?: boolean;
  $pointer?: boolean;
}

type MarginType = 'none' | 'small' | 'normal' | 'large';

export interface TitleProps extends TextProps {
  $marginTop?: MarginType;
  $marginBottom?: MarginType;
}

const marginSizes: Record<MarginType, CSSProperties['marginTop']> = {
  large: '2rem',
  normal: '1rem',
  small: '0.5rem',
  none: 0,
};

const getTextColor = ($type?: TextType) => {
  switch ($type) {
    case 'danger':
      return css`
        color: ${COLORS.DANGER};
      `;
    case 'warning':
      return css`
        color: ${COLORS.WEB_ORANGE};
      `;
    case 'primary':
      return css`
        color: ${COLORS.PRIMARY};
      `;
    case 'success':
      return css`
        color: ${COLORS.SUCCESS};
      `;
    case 'light':
      return css`
        color: ${COLORS.GREY};
      `;
    case undefined:
    case 'default':
    default:
      return;
  }
};

export const Text = styled.span<TextProps>`
  ${({ $maxWidth, $width }) => {
    if (!($maxWidth || $width)) {
      return;
    }

    return css`
      display: inline-block;
      ${$maxWidth ? `max-width: ${$maxWidth};` : ''}
      ${$width ? `width: ${$width};` : ''}
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `;
  }}

  text-align: ${({ $center, $right }) => {
    if ($center) return 'center';
    if ($right) return 'right';
    return 'left';
  }};
  ${({ $pointer }) => $pointer && `cursor: pointer;`}

  ${({ $type }) => getTextColor($type)}


  font-size: ${({ $size = 'normal' }) => STYLE.TEXT_FONT_SIZE[$size]};
  ${({ $bold, $semiBold }) => {
    if ($bold) {
      return 'font-weight: 700;';
    }
    if ($semiBold) {
      return 'font-weight: 500;';
    }
  }}
  ${({ $italic }) => {
    if ($italic) {
      return 'font-style: italic;';
    }
  }}
`;

export const Title = styled.div<TitleProps>`
  font-size: ${({ $size = 'normal' }) => STYLE.TITLE_FONT_SIZE[$size]};
  font-weight: 500;
  line-height: 1.3;
  white-space: normal;

  ${({ $marginTop }) =>
    $marginTop &&
    css`
      margin-top: ${marginSizes[$marginTop]};
    `}
  ${({ $marginBottom }) =>
    $marginBottom &&
    css`
      margin-bottom: ${marginSizes[$marginBottom]};
    `}

  ${({ $type }) => getTextColor($type)}
`;
